import { type BentoCard } from './bento-grid';
import { CONNECTIONS } from './platform-connections';

export const CARDS_AR: BentoCard[] = [
  {
    id: 'omnichannel',
    title: 'كل القنوات، عقل واحد',
    description:
      'مكالمات، دردشة، إيميل، WhatsApp، Slack، وسوشيال. وكيلك الذكي يحضر بنفس النبرة ونفس السياق بكل مكان يجيك منه العميل، وبدون ما تبني كل قناة من جديد.',
    image: 'https://platform.open.cx/changelog/phone-agent-workflows.jpg',
    layout: 'horizontal',
    modal: {
      eyebrow: 'كل القنوات من الأساس',
      headline: 'محرك AI واحد يشغّل كل قنواتك',
      lead: 'أغلب المزوّدين يبيعونك بوت دردشة، وبوت صوت منفصل، ومجاوب إيميل ثالث. ثلاثة منتجات، وثلاث فواتير، وثلاثة أشياء لازم تخليها متطابقة. Open وكيل واحد، وعقل واحد، بكل مكان يجيك منه العميل.',
      blocks: [
        {
          type: 'text',
          body: [
            'كل بوت منفصل يجي بإعداده الخاص، وقاعدة معرفته، ونبرته. والعميل يحس بالفرق من أول ثانية ينتقل فيها من الدردشة للمكالمة ويبدأ من الصفر. وداخلياً، فريقك يحدّث نفس الجواب في أربعة أماكن، وبعدها يشوف النسخ تتباعد شي فشي. أربع نسخ، ولا وحدة تشبه الثانية.',
            'Open يجمعها كلها في وكيل واحد: شخصية واحدة، ومصدر حقيقة واحد. تكتب التعليمة مرة وحدة وتشتغل على كل قناة خلال ثوانٍ. بلا نسخ ولصق، ولا فحص لكل قناة، ولا فرق بين قناة وقناة.',
          ],
        },
        {
          type: 'video',
          src: '/home/channels.mp4',
          caption:
            'نفس الوكيل، يشتغل لحظياً على الدردشة والصوت والإيميل وWhatsApp والسوشيال.',
        },
        {
          type: 'stats',
          items: [
            { value: '٨+', label: 'قنوات، ووكيل واحد' },
            { value: '١', label: 'عقل معرفة واحد' },
            { value: '٠', label: 'إعادة بناء لأي قناة' },
          ],
        },
        {
          type: 'text',
          heading: 'سياق ينتقل مع العميل',
          body: 'العميل يبدأ بالدردشة، ويصعّد لمكالمة، ويخلّص عبر الإيميل، وبدون ما يعيد كلامه ولا مرة. سجل المحادثة كامل، وسياق حسابه، وكل إجراء تنفّذ، ينتقل معه في كل تحويل. للـ AI، ولأي موظف يدخل على الخط.',
        },
        {
          type: 'channels',
          heading: 'اكتشف قنواتنا',
          subheading: 'كل قناة تستخدم نفس الوكيل. تعرّف على كل وحدة منها.',
          items: [
            { name: 'Voice', href: '/channels/voice' },
            { name: 'Chat', href: '/channels/chat' },
            { name: 'Email', href: '/channels/email' },
            { name: 'WhatsApp', href: '/channels/whatsapp' },
            { name: 'Slack', href: '/channels/slack' },
            { name: 'Social', href: '/channels/social' },
          ],
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'لازم أجهّز كل قناة على حدة؟',
              a: 'لا. وكيل واحد، وقاعدة معرفة واحدة، ومجموعة ضوابط واحدة تخدم كل القنوات. تحدّث التعليمة مرة وحدة وتشتغل بكل مكان خلال ثوانٍ.',
            },
            {
              q: 'تقدر المحادثة تنتقل بين القنوات؟',
              a: 'نعم. العميل يبدأ بالدردشة، ويصعّد لمكالمة، ويخلّص عبر الإيميل. والسجل والسياق ينتقلون معه في كل تحويل، للـ AI ولأي موظف يدخل على الخط.',
            },
            {
              q: 'وش القنوات المدعومة؟',
              a: 'مكالمات، وشات، وإيميل، وSMS، وWhatsApp، وInstagram، وMessenger، وSlack، وDiscord، مع نظام اتصال هاتفي مدمج من الأساس.',
            },
            {
              q: 'تشتغلون مع نظام الهاتف عندي؟',
              a: 'أحضر رقمك معك، أو اربط Twilio أو Vonage أو RingCentral. إضافة قناة جديدة تاخذ أيام، مو ربع سنة.',
            },
          ],
        },
      ],
      cta: { label: 'شوفه وهو يشتغل', href: '/demo' },
    },
  },
  {
    id: 'workflows',
    title: 'سير عمل ينفّذ فعلاً',
    description:
      'مبالغ مستردة، تغييرات حساب، وش ما كانت مشكلتك. الوكيل مو بس يتكلم، ينادي الـ APIs عندك ويخلّص المهمة.',
    image: 'https://platform.open.cx/changelog/companion-planning-mode.jpg',
    layout: 'vertical',
    modal: {
      eyebrow: 'سير العمل الذكي',
      headline: 'إجراءات حقيقية، مو تهرّب من السؤال',
      lead: 'نصف اللي يوصلك مو أسئلة تنتظر جواب، بل طلبات تنتظر تنفيذ. وإحالة العميل لمقال مساعدة ما تنفّذ له طلب. وكيل Open يتصل بأنظمتك، ويخلّص المهمة داخل نفس المحادثة.',
      blocks: [
        {
          type: 'text',
          body: [
            'يعالج مبلغاً مسترداً في Stripe، ويحدّث عنوان الشحن في Shopify، ويعيد ضبط كلمة المرور، ويضيف رصيداً للحساب، ويصعّد إلى المهندس المناوب في PagerDuty. وبدل ما يدلّ العميل وين يضغط، هو اللي يضغط. ينادي الـ APIs عندك، ويكمل المهمة من أولها لآخرها، ويرجع للعميل بلغة واضحة يشرح فيها وش صار بالضبط.',
            'وكم صلاحية يملك الوكيل؟ أنت اللي تحددها بالضبط. الإجراءات قليلة الخطورة تجري لحظياً، وأي إجراء حساس يوقف وينتظر موافقة بشرية بضغطة وحدة في Slack، والسياق كامل مرفق معه.',
          ],
        },
        {
          type: 'video',
          src: '/home/integrations.mp4',
          caption: 'تكاملات أصلية مع Stripe وShopify وSalesforce و١٠٠+ أداة.',
        },
        {
          type: 'stats',
          items: [
            { value: '١٠٠+', label: 'تكامل أصلي' },
            { value: '١٠٠٪', label: 'من الإجراءات في سجل التدقيق' },
            { value: 'أقل من ساعة', label: 'لإطلاق سير عمل' },
          ],
        },
        {
          type: 'text',
          heading: 'ابنه على كيفك',
          body: 'ركّب سير العمل في محرر مرئي يديره فريق العمليات عندك بنفسه، أو انتقل لكود مخصص لمّا يصير المنطق معقّد. كل تشغيل يجري في بيئة معزولة، ومعه سجل تدقيق كامل: وش صار، وبموافقة مين، ووش تغيّر. تعطي الوكيل قوة حقيقية، وتبقى أنت اللي بيدك القرار.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'الوكيل ينفّذ فعلاً، ولا بس يجاوب؟',
              a: 'ينفّذ فعلاً. ينادي الـ APIs عندك عشان يعالج المبالغ المستردة، ويحدّث العناوين، ويعيد ضبط كلمات المرور، ويصعّد، ويكمل المهمة داخل نفس المحادثة، ويأكدها بلغة واضحة.',
            },
            {
              q: 'كيف أضمن أمان الإجراءات الخطيرة؟',
              a: 'كل إجراء يجري في بيئة معزولة، ومعه سجل تدقيق كامل. والخطوات عالية الخطورة توقف وتنتظر موافقة بشرية بضغطة وحدة في Slack، والسياق كامل مرفق معه.',
            },
            {
              q: 'وش يقدر يتكامل معه؟',
              a: 'Stripe وShopify وSalesforce و١٠٠+ أداة بتكامل أصلي، وأي API داخلي أو قاعدة بيانات تفتحها له.',
            },
            {
              q: 'أحتاج مهندسين حتى أبني سير العمل؟',
              a: 'لا. فريق العمليات يركّب سير العمل في أداة بناء مرئية، وما ينتقل للكود المخصص إلا لمّا يصير المنطق معقّد.',
            },
          ],
        },
      ],
      cta: { label: 'استكشف سير العمل', href: '/workflows' },
    },
  },
  {
    id: 'knowledge',
    title: 'فاهم شغلك',
    description:
      'يستخرج مستنداتك بنفسه، ويتعلّم من كل تذكرة تنحل، ويرجّع أي تغيير بضغطة وحدة.',
    image: 'https://platform.open.cx/changelog/ai-instructions-ui.jpg',
    layout: 'vertical',
    modal: {
      eyebrow: 'تعلّم مستمر',
      headline: 'قاعدة معرفة تصون نفسها',
      lead: 'مركز المساعدة عندك، والويكي الداخلي، وسجل تحديثات المنتج، كلها تتغيّر كل يوم. وأي وكيل تدرّب على نسخة ثابتة يصير غلط خلال أسبوع. Open يتطور مع منتجك، تلقائياً.',
      blocks: [
        {
          type: 'text',
          body: [
            'Open يزامن مصادرك باستمرار، ويرصد الجواب لمّا يصير قديم، ويؤشّر على الأسئلة اللي ما يقدر يجاوب عليها بثقة بعد. وبدل ما تخمّن وش توثّق، تحصل على قائمة مرتّبة بالأسئلة اللي يسألها عملاؤك وقاعدة معرفتك ما عندها جواب لها. بلا تخمين.',
            'والنتيجة؟ وكيل يزيد دقة كل ما زاد استخدامه، وفريق يقضي وقته في سدّ ثغرات حقيقية بدل ما يدقّق وش قال الذكاء الاصطناعي.',
          ],
        },
        {
          type: 'video',
          src: '/home/data-sources.mp4',
          caption:
            'مزامنة تلقائية من Notion وConfluence وZendesk وIntercom، ومن زحف مباشر للويب.',
        },
        {
          type: 'logos',
          variant: 'grid',
          heading: 'اربط أي مصدر',
          subheading:
            'كل قاعدة معرفة، ونظام دعم، وأداة ندعمها تشتغل بدون إعداد. وأي مصدر يتصل به Airbyte، وأي REST API.',
          items: CONNECTIONS,
        },
        {
          type: 'stats',
          items: [
            { value: '٥٠+', label: 'مصدر مدعوم' },
            { value: 'ضغطة واحدة', label: 'للرجوع إلى أي نسخة' },
            { value: '٢٤/٧', label: 'مراقبة حداثة الأجوبة' },
          ],
        },
        {
          type: 'text',
          heading: 'نسخة لكل تغيير، ورجعة من كل غلط',
          body: 'كل تعليمة، وكل تغيير في المعرفة، له نسخة محفوظة. وإذا نزّل تعديل صغير نسبة الحل بهدوء، ارجع بضغطة وحدة وشوف وش تغيّر بالضبط، ومين غيّره، ومتى. ما في شي في وكيلك صندوق أسود.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'كيف الوكيل يظل محدّث؟',
              a: 'يزامن مصادرك باستمرار، Notion وConfluence وZendesk وIntercom وGoogle Docs وزحف مباشر للويب، ويؤشّر تلقائياً على أي جواب صار قديم.',
            },
            {
              q: 'وش لو طلع تغيير بنتيجة أسوأ؟',
              a: 'كل تعليمة لها نسخة. وإذا نزّل تعديل نسبة الحل عندك، ارجع بضغطة وحدة، وشوف وش تغيّر بالضبط، ومين غيّره، ومتى.',
            },
            {
              q: 'كيف أعرف وش الناقص؟',
              a: 'كشف ثغرات المعرفة يرتّب لك الأسئلة اللي يسألها العملاء وقاعدة معرفتك ما عندها جواب لها بعد، عشان تسدّ ثغرات حقيقية بدل التخمين.',
            },
            {
              q: 'يتعلّم من فريقي؟',
              a: 'نعم. يتعلّم من كل تذكرة يحلّها موظف، ويزيد دقة كل ما زاد استخدامه.',
            },
          ],
        },
      ],
      cta: { label: 'شوف ثغرات المعرفة', href: '/knowledge-gap-detection' },
    },
  },
  {
    id: 'helpdesk',
    title: 'يعمل مع أي نظام دعم',
    description:
      'Zendesk، Intercom، Salesforce، HubSpot، Freshdesk، Twilio Flex، أو نظام Open نفسه. يستخدم على النظام اللي تشغّله أصلاً. بدون ترحيل.',
    image: 'https://platform.open.cx/changelog/versioning-audit.jpg',
    layout: 'vertical',
    modal: {
      eyebrow: 'تكاملات أصلية',
      headline: 'يستخدم على نظام الدعم اللي تشغّله أصلاً',
      lead: 'بلا قلع وتبديل، ولا ترحيل بيانات، ولا إعادة تدريب لفريقك. Open يتصل بنظام الدعم عندك، ويشتغل على تذاكرك جنب موظفيك، ويرجّع مزامنة كل تغيير مع نظامك. وما أحد يحتاج يطلع من الأدوات اللي يعرفها.',
      blocks: [
        {
          type: 'text',
          body: [
            'تبديل نظام الدعم من أصعب المشاريع اللي يتحملها فريق دعم: شهور ترحيل، وسجل يضيع، وفريق يعيد تعلّم كل شي من الصفر. Open يتخطى هذا كله. يتصل بمنصتك الحالية بتكامل عميق وأصلي، ويبدأ يحل التذاكر من أول يوم.',
            'الـ AI يتولّى المحادثات في نفس صندوق الوارد اللي يشتغل فيه موظفوك أصلاً. وعند التحويل، الموظف يشوف الخيط كامل. ولمّا يحل موظف تذكرة، الـ AI يتعلّم منها. وما أحد يحتاج يتنقل بين نظامين.',
          ],
        },
        {
          type: 'video',
          src: '/home/ticketing-system.mp4',
          caption: 'Open يشتغل على تذاكرك بشكل أصلي، داخل نظام الدعم عندك.',
        },
        {
          type: 'stats',
          items: [
            { value: '٧+', label: 'أنظمة دعم مدعومة' },
            { value: 'أقل من ساعة', label: 'للربط' },
            { value: '٠', label: 'ترحيل مطلوب' },
          ],
        },
        {
          type: 'logos',
          heading: 'أصلي على نظام الدعم عندك',
          subheading:
            'تكاملات عميقة وثنائية الاتجاه مع المنصات اللي تشغّلها أصلاً.',
          items: [
            {
              name: 'Zendesk',
              src: '/helpdicks/zendesk.png',
              href: '/helpdesks/zendesk',
            },
            {
              name: 'Intercom',
              src: '/helpdicks/intercom.png',
              href: '/helpdesks/intercom',
            },
            {
              name: 'Salesforce',
              src: '/helpdicks/salesforce.png',
              href: '/helpdesks/salesforce',
            },
            {
              name: 'HubSpot',
              src: '/helpdicks/hubspot.png',
              href: '/helpdesks/hubspot',
            },
            {
              name: 'Freshdesk',
              src: '/helpdicks/freshdesk.png',
              href: '/helpdesks/freshdesk',
            },
            {
              name: 'Twilio Flex',
              src: '/helpdicks/flex.png',
              href: '/helpdesks/twilio-flex',
            },
            {
              name: 'Front',
              src: '/helpdicks/front.png',
              href: '/helpdesks/open',
            },
            {
              name: 'Open Helpdesk',
              src: '/open-logo.svg',
              href: '/helpdesks/open',
            },
          ],
        },
        {
          type: 'text',
          heading: 'مزامنة عميقة وثنائية الاتجاه',
          body: 'هذا أكثر من مجرد webhook. التذاكر، والوسوم، والماكرو، والحقول المخصصة، والمسؤولون، والملاحظات الداخلية، وCSAT، كلها تتدفّق في الاتجاهين لحظياً. تقاريرك تبقى دقيقة، وأتمتتك تستمر تشتغل، وSLAs عندك تبقى تُحتسب بدقة. والـ AI يصير أسرع زميل في الفريق، ما يتوقف، ويشتغل ٢٤/٧ داخل نظام السجلات اللي تثق به أصلاً.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'لازم أرحّل من نظام الدعم الحالي؟',
              a: 'لا. Open يستخدم على المنصة اللي تشغّلها أصلاً، ويبدأ يحل التذاكر من أول يوم. بلا ترحيل، ولا سجل يضيع.',
            },
            {
              q: 'وش أنظمة الدعم اللي تدعمونها؟',
              a: 'Zendesk وIntercom وSalesforce Service Cloud وHubSpot Service Hub وFreshdesk وTwilio Flex، ونظامنا Open Helpdesk. والمنصات المخصصة عن طريق REST API وwebhooks.',
            },
            {
              q: 'يؤثر على تقاريري وأتمتتي؟',
              a: 'لا. التذاكر، والوسوم، والماكرو، والحقول المخصصة، والمسؤولون، وCSAT، كلها تتزامن في الاتجاهين لحظياً. تقاريرك تبقى دقيقة، وSLAs عندك تبقى تُحتسب بدقة.',
            },
            {
              q: 'كم ياخذ الربط؟',
              a: 'أقل من ساعة، بتكامل عميق وأصلي. وفريقك يبقى في الأدوات اللي يعرفها، وما يتغير عليه شي.',
            },
          ],
        },
      ],
      cta: { label: 'شوف كل أنظمة الدعم', href: '/helpdesks' },
    },
  },
];

export const SECTION_AR = {
  title: 'أتمتة الدعم وتوحيده',
  subtitle:
    'محرك AI واحد يشتغل على كل القنوات بنفس القوة. ثابت ما يتذبذب، وتعتمد عليه شركات كبيرة شغلها ما يحتمل غلط.',
};
